import { useQuery } from '@tanstack/react-query';
import { http } from '@/network/http';

export function useSettings() {
  return useQuery({
    queryKey: ['system-settings'],
    queryFn: async () => {
      const { data } = await http.get<{ success: boolean; settings: Record<string, string> }>('/settings');
      return data.settings;
    },
    staleTime: 5 * 60 * 1000,
  });
}
